module.exports = __webpack_public_path__ + "media/theme/tutorial__mobage--3--create-65b10139.png";